<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <CIcon v-if="!minimize" src="/img/assets_ai_white.svg" :height="40" />
      <CIcon v-if="minimize" src="/img/dracio_white_small.svg" :height="40" />
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="navigation"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav'

export default {
  name: 'TheSidebar',
  //nav,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    },
    navigation () {
      var nav2 = nav
      if(localStorage.role != 'super') {
        for(var idx=0; idx < nav2[0]._children.length; idx++) {
          if(nav2[0]._children[idx].module !== undefined) {
            console.log(nav2[0]._children[idx].module, localStorage.modules.includes(nav2[0]._children[idx].module))
            if(!localStorage.modules.includes(nav2[0]._children[idx].module)) nav2[0]._children.splice(idx--, 1)
          }
        }
      }
      return nav2
    }
  }
}
</script>
